"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  PermissionsProvider: true,
  usePermissions: true,
  Permissions: true
};
Object.defineProperty(exports, "PermissionsProvider", {
  enumerable: true,
  get: function get() {
    return _PermissionsProvider["default"];
  }
});
Object.defineProperty(exports, "usePermissions", {
  enumerable: true,
  get: function get() {
    return _usePermissions["default"];
  }
});
Object.defineProperty(exports, "Permissions", {
  enumerable: true,
  get: function get() {
    return _Permissions["default"];
  }
});

var _PermissionsContext = require("./PermissionsContext");

Object.keys(_PermissionsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PermissionsContext[key];
    }
  });
});

var _PermissionsProvider = _interopRequireDefault(require("./PermissionsProvider"));

var _usePermissions = _interopRequireDefault(require("./usePermissions"));

var _Permissions = _interopRequireDefault(require("./Permissions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUNBOztBQUNBOztBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSAnLi9QZXJtaXNzaW9uc0NvbnRleHQnO1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBQZXJtaXNzaW9uc1Byb3ZpZGVyIH0gZnJvbSAnLi9QZXJtaXNzaW9uc1Byb3ZpZGVyJztcbmV4cG9ydCB7IGRlZmF1bHQgYXMgdXNlUGVybWlzc2lvbnMgfSBmcm9tICcuL3VzZVBlcm1pc3Npb25zJztcbmV4cG9ydCB7IGRlZmF1bHQgYXMgUGVybWlzc2lvbnMgfSBmcm9tICcuL1Blcm1pc3Npb25zJztcbiJdfQ==